import React, { Component } from "react";
import { ModuleAccordionGroup } from "@loanbossinc/component-library";
import { AccordionSection } from "component-lib/AccordionSection";

import { LOAN_SECTION_KEYS } from "../loan.constants";
import { findSummaryText } from "../loanDetailEditUtil";

import { rows as sectionPrepaymentDetailsRows } from "./section-details-rows";

const SHORTHAND_FIELD = "LoanPrepaymentDetails";

const nullData = {
  stylename: "Work Sans /  16 Regular",
  fontFamily: "Work Sans",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "19px",
  letterSpacing: "0em",
  textAlign: "center",
  textColor: "#7d8084"
};

export class LoanPrepaymentDetails extends Component {
  drawDataPrepaymentDetails(data) {
    if (data.prepaymentTerms) {
      if (data.prepaymentTerms.prepaymentType ||
        data.prepaymentTerms.exitFee ||
        data.prepaymentTerms.lockoutPeriod ||
        data.prepaymentTerms.noticePeriod) {
        return <AccordionSection eventHandlers={this.props.eventHandlers} rows={sectionPrepaymentDetailsRows} data={data} />;
      }
    } else {
      return (<p style={nullData}>Data has not been entered for this section.</p>);
    }
  }

  render() {
    const { data, history, loanId, enableEditButton, modifySummaryText, eventHandlers, ...other } = this.props;
    const summaryText = findSummaryText(data, SHORTHAND_FIELD);

    if (!data) {
      return null;
    }

    return (
      <ModuleAccordionGroup
        {...other}
        groups={[
          {
            title: "Prepayment Details",
            key: LOAN_SECTION_KEYS.LOAN_PREPAYMENT_DETAILS,
            isTitleGroup: true,
            isExpandable: true,
            buttonLabel: "Edit Details",
            showEditButton: enableEditButton,
            onClick: () => history.push(`/loans/${loanId}/edit/${LOAN_SECTION_KEYS.LOAN_PREPAYMENT_DETAILS}`),
            hasSummaryText: true,
            summaryText,
            modifySummaryText: () => modifySummaryText(SHORTHAND_FIELD, summaryText),
            sections: [
              this.drawDataPrepaymentDetails(data)
            ],
            references: data.references,
            eventHandlers,
            referencedFieldPath: "loans.prepaymentdetails.header",
            referenceStyles: { marginLeft: "20px" }
          }
        ]}
      />
    );
  }
}
